"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Base {
  constructor() {
    _defineProperty(this, "_id", null);

    _defineProperty(this, "type", 'base');

    _defineProperty(this, "ref_id", null);

    _defineProperty(this, "name", "");

    _defineProperty(this, "edges", []);

    _defineProperty(this, "doughs", []);

    _defineProperty(this, "items", []);

    _defineProperty(this, "price", 0.00);

    _defineProperty(this, "originalPrice", 0.00);

    _defineProperty(this, "quantity", 1);

    _defineProperty(this, "image", null);

    _defineProperty(this, "parent_ref", null);

    _defineProperty(this, "parent", null);

    _defineProperty(this, "observation", null);

    _defineProperty(this, "description", null);

    _defineProperty(this, "extra_ingredients", []);

    _defineProperty(this, "position", null);

    _defineProperty(this, "delete", false);

    _defineProperty(this, "new", false);

    _defineProperty(this, "show", true);

    _defineProperty(this, "selected", false);

    _defineProperty(this, "highlight", false);

    _defineProperty(this, "sizes", []);

    _defineProperty(this, "group", null);

    _defineProperty(this, "availability", null);

    _defineProperty(this, "categoryName", "");

    _defineProperty(this, "addItems", items => {
      let toProcess = !Array.isArray(items) ? [items] : items;
      let me = this;
      toProcess.map(v => {
        v.parent_ref = me;

        switch (v.type) {
          case 'dough':
            v.position = v.position || v.position === 0 ? v.position : me.doughs.length;
            me.doughs.push(v);
            break;

          case 'edge':
            v.position = v.position || v.position === 0 ? v.position : me.edges.length;
            me.edges.push(v);
            break;

          case 'extraingredient':
            v.position = v.position || v.position === 0 ? v.position : me.extra_ingredients.length;
            me.extra_ingredients.push(v);
            break;

          case 'size':
            v.position = v.position || v.position === 0 ? v.position : me.sizes.length;
            me.sizes.push(v);
            break;

          default:
            if (me.type === 'catalog' && !me.items.every(item => item.type === 'category')) {
              v.position = me.items.length;
            } else {
              v.position = v.position || v.position === 0 ? v.position : me.items.length;
            }

            me.items.push(v);
            break;
        }
      });
    });

    _defineProperty(this, "list", $class => {
      let tmpList = this.constructor.name == $class ? [this] : [],
          me = this;
      ['edges', 'extra_ingredients', 'sizes', 'items', 'doughs'].map(property => {
        me[property].map(item => {
          let childList = item.list($class) || [];
          tmpList.push(...childList);
        });
      });
      return tmpList;
    });

    _defineProperty(this, "getItemsByParam", (param, value) => {
      let list = this[param] == value ? [this] : [],
          me = this;
      ['edges', 'extra_ingredients', 'sizes', 'items', 'doughs'].map(property => {
        return me[property] && me[property].map(item => {
          let childList = item.getItemsByParam ? item.getItemsByParam(param, value) : [];
          if (childList.length > 0) list = list.concat(...childList);
        });
      });
      return list;
    });

    _defineProperty(this, "toJSON", () => {
      let me = this;
      delete me.parent_ref;
      return me;
    });

    _defineProperty(this, "getPrice", computeValueFunction => {
      let me = this;
      let price = +(+this.price > 0 && (computeValueFunction ? computeValueFunction(this) : true) ? +this.price : 0);

      let extra_ingredients = function () {
        if (!me.extra_ingredients || me.extra_ingredients.length == 0) {
          return 0;
        }

        return +me.extra_ingredients.reduce((carry, item) => carry + (+item.getPrice(computeValueFunction) > 0 ? +item.getPrice(computeValueFunction) : 0), 0);
      }();

      if (!this.items || this.items.length == 0) {
        return (+this.quantity || 1) * (+price + extra_ingredients);
      }

      return (+this.quantity || 1) * (price + this.items.reduce((carry, item) => carry + (+item.getPrice(computeValueFunction) > 0 ? +item.getPrice(computeValueFunction) : 0), 0) + extra_ingredients);
    });
  }

  isValid() {
    return true;
  }

  getValidity() {
    let me = this;
    let isValid = this.isValid() && ['edges', 'extra_ingredients', 'sizes', 'items', 'doughs'].map(property => me[property].reduce((carry, item) => carry && item.getValidity(), true)).reduce((carry, isValid) => carry && isValid, true);
    return isValid;
  }

}

exports.default = Base;